import { Component } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { TimeOffApprovalFlow } from '@models/time-off-v3/time-off-approval-flow.model';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';

@Component({
    selector: 'app-assign-approval-flow-form',
    templateUrl: './assign-approval-flow.template.html',
    styleUrls: ['./assign-approval-flow.style.scss'],
})
export class AssignApprovalFlowForm extends BaseForm {
    approvalFlow: TimeOffApprovalFlow = new TimeOffApprovalFlow();
    selectedPoliciesIds: number[] = [];
    private _policies: TimeOffPolicy[] = [];
    private _alreadyAssigned: TimeOffPolicy[] = [];

    get policies(): TimeOffPolicy[] {
        return [...this._alreadyAssigned, ...this._policies];
    }

    get selectedPolicies(): TimeOffPolicy[] {
        return this.selectedPoliciesIds.map((id: number) =>
            this.policies.find((policy: TimeOffPolicy) => policy.id === id)
        );
    }

    async beforeShow(): Promise<void> {
        const [policies]: [TimeOffPolicy[], any] = await TimeOffPolicy.with('timeOffType').all();
        this._policies = [];
        this._alreadyAssigned = [];
        this.selectedPoliciesIds = [];

        policies.forEach((policy: TimeOffPolicy) => {
            if (policy.timeOffApprovalFlowId === this.approvalFlow.id) {
                this._alreadyAssigned.push(policy);
                return;
            }

            this._policies.push(policy);
        });
    }

    isAlreadyAssigned(policy: TimeOffPolicy): boolean {
        return this._alreadyAssigned.map((_policy: TimeOffPolicy) => _policy.id).includes(policy.id);
    }
}
